import {RestClient} from "zavadil-ts-common";
import {TargetGroup} from "../../types/TargetGroup";

export class TargetGroupsClient {

	client: RestClient;

	constructor(client: RestClient) {
		this.client = client;
	}

	all(): Promise<Array<TargetGroup>> {
		return this.client.getJson('target-group/all');
	}

}
